import { graphql } from '~publish/gql'

import { useTypedMutation } from '../../hooks/useTypedMutation'

export const ApprovePost = graphql(/* GraphQL */ `
  mutation ApprovePost($id: PostId!) {
    approvePost(input: { id: $id }) {
      __typename
      ... on MutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          status
          dueAt
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useApprovePost = () =>
  useTypedMutation(ApprovePost, (data) => data.approvePost, {
    successTypename: 'PostActionSuccess',
  })
